import React from "react";
import arrowImg from "../../../../../assests/icons/arrow.svg";
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import classes from "./Arrow.module.css";


const Arrow = ({ direction, dropClass }) => {
    return <AccessibilityHiddenImg className={`${classes.Arrow} ${classes[direction]} ${dropClass}`} src={arrowImg} />
}
export default Arrow;   